import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { select, Store } from '@ngrx/store';
import {
  SpecificationLoadCatalogsAction,
  SpecificationLoadProjectProfilesAction,
} from '@ordersnproducts/modules/order-builder/modules/specification/actions/specification.actions';
import { getAvailableProducts } from '../../../selectors/products.selectors';
import { filter, map, take } from 'rxjs/operators';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

@Injectable()
export class LoadCatalogs implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getAvailableProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) => products.find((product) => product.comm_product.comm_product.replace(/^0+/, '') === value)),
      )
      .subscribe((product) => {
        if (product) {
          this.store.dispatch(new SpecificationLoadCatalogsAction());
          this.store.dispatch(new SpecificationLoadProjectProfilesAction());
        }
      });
  }
}
